export default function Memberships() {
  const memberships = [
    { 
      name: 'MSME', 
      logo: 'https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/1a899ca81333f28c6cc5dfffc716e132.jpeg'
    }
  ];

  return (
    <section id="memberships" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Memberships & <strong className="text-teal-600">Associations</strong>
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Certified and recognized by leading trade organizations
          </p>
        </div>

        <div className="flex justify-center">
          {memberships.map((membership, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 border border-gray-100 max-w-xs"
            >
              <div className="w-32 h-32 bg-white rounded-lg flex items-center justify-center mb-4 mx-auto overflow-hidden">
                <img 
                  src={membership.logo} 
                  alt={membership.name}
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-lg font-semibold text-gray-700 text-center">
                {membership.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
